module.exports = __webpack_public_path__ + "static/media/scrollToTop.5c831ffe.svg";